module.exports = __webpack_public_path__ + "static/media/arenafm.46a0cccd.png";